import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { commonMessages } from '../../i18n/commonMessages';
import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';

const styles = css`
	position: relative;

	& > .icon {
		color: white;
		cursor: pointer;
		font-size: 16px;
		position: absolute;
		right: 18px;
		top: calc(50% - 8px);
	}
`;
const Component = ({ className }: { className: string }): ReactElement => {
	const intl = useIntl();
	return (
		<div className={className}>
			<span>{intl.formatMessage(commonMessages.chat)}</span>
		</div>
	);
};
export const InvolveHeader = styled(Component)(
	({
		theme: {
			chat: {
				header: { chatHeader },
			},
		},
	}: {
		theme: Theme;
	}) => chatHeader,
	styles
);
